import React from 'react';

export interface BlockRendererProps {
  block: { settings: Record<string, any> };
  config: {
    anaRenk: string;
    aksanRenk: string;
    font: string;
    fontBoyutu: number;
    odemeKosullari?: string;
    gecerlilikNotu?: string;
    altBilgiNotu?: string;
  };
  offer?: any;
  offerType?: 'given' | 'received';
  companyInfo?: any;
}

const SignatureBlockRenderer: React.FC<BlockRendererProps> = ({ block, config }) => {
  const s = block?.settings ?? {};
  const name = s.name != null ? String(s.name) : '';
  const title = s.title != null ? String(s.title) : '';
  const showStamp = s.showStamp === true;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
        marginTop: '24px',
        fontFamily: `'${config.font}', Arial, sans-serif`,
        fontSize: `${config.fontBoyutu}px`,
        color: '#333',
      }}
    >
      <div style={{ minWidth: '220px', maxWidth: '280px', textAlign: 'right' as const }}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', alignItems: 'flex-end' }}>
          {showStamp ? (
            <div
              style={{
                width: '72px',
                height: '72px',
                border: `2px dashed ${config.aksanRenk}`,
                borderRadius: '6px',
                flexShrink: 0,
                opacity: 0.85,
              }}
              aria-hidden
            />
          ) : null}
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ borderBottom: '1px solid #333', minHeight: '36px', marginBottom: '8px' }} />
            {name ? <div style={{ fontWeight: 600, marginBottom: '4px' }}>{name}</div> : null}
            {title ? <div style={{ fontSize: `${Math.max(config.fontBoyutu - 1, 10)}px`, color: '#666' }}>{title}</div> : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignatureBlockRenderer;
